import AspApi from 'api/ApiConfig';

export const getSequenceOverviewContactlists = async (seqId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);
  if (payload?.status) qpm.push(`status=${payload?.status}`);
  if (payload?.order) qpm.push(`order=${payload?.order}`);
  if (payload?.sort) qpm.push(`sort=${payload?.sort}`);
  if (payload?.search) qpm.push(`search=${payload?.search}`);
  if (payload?.limit) qpm.push(`limit=${payload?.limit}`);
  if (payload?.page) qpm.push(`page=${payload?.page}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/sequence_contact_overview${qpmString}`
  );

  return res;
};

export const getSequenceActivitesCard = async (seqId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/sequence_activities${qpmString}`
  );

  return res;
};

export const updateSequenceStatus = async (seqId, payload) => {
  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/change_state`,
    payload
  );

  return res;
};

export const getSequenceOverviewPerformenceMetrics = async (seqId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);
  if (payload?.startData) qpm.push(`from_date=${payload?.startData}`);
  if (payload?.endDate) qpm.push(`to_date=${payload?.endDate}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const res = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/performance_metrics${qpmString}&timezone=${userTimeZone}`
  );

  return res;
};

export const getSequenceOverviewPreview = async (seqId, payload) => {
  let qpm = [];
  if (payload?.brandId) qpm.push(`brand_id=${payload?.brandId}`);
  if (payload?.campaignId) qpm.push(`campaign_id=${payload?.campaignId}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.get(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/previews/show${qpmString}`
  );

  return res;
};

// PREVIEW
export const previewSendButtonClick = async (seqId, query, payload) => {
  let qpm = [];
  if (query?.brandId) qpm.push(`brand_id=${query?.brandId}`);
  if (query?.campaignId) qpm.push(`campaign_id=${query?.campaignId}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/previews/${query?.previewId}${qpmString}`,
    payload
  );
  return res;
};

export const previewSendCustomTextMessage = async (seqId, query, payload) => {
  let qpm = [];
  if (query?.brandId) qpm.push(`brand_id=${query?.brandId}`);
  if (query?.campaignId) qpm.push(`campaign_id=${query?.campaignId}`);
  if (query?.trigger_type) qpm.push(`trigger_type=${query?.trigger_type}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/previews/${query?.previewId}/compose${qpmString}`,
    payload
  );
  return res;
};

export const previewResetMessage = async (seqId, query) => {
  let qpm = [];
  if (query?.brandId) qpm.push(`brand_id=${query?.brandId}`);
  if (query?.campaignId) qpm.push(`campaign_id=${query?.campaignId}`);
  if (query?.trigger_type) qpm.push(`trigger_type=${query?.trigger_type}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString = '?' + qpm.join('&');

  const res = await AspApi.put(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/previews/${query?.previewId}/reset${qpmString}`
  );
  return res;
};

export const exportAllContacts = async (seqId, payload = {}) => {
  const res = await AspApi.post(
    `/api/v1/svc/campaign_sequence/sequences/${seqId}/export_contacts_metrics`,
    payload
  );
  return res;
};
